/*
 * Copyright (c) Orion Developments Ltd and the Orion Health group of companies (2001 - 2021).
 *
 * This document is subject to copyright. Except as permitted by copyright law
 * applicable to you, no part of this publication may be reproduced or
 * transmitted in any form or by any means, electronic or mechanical, including
 * photocopying, recording, downloading, or any information storage and
 * retrieval system, without permission in writing from Orion Developments
 * Limited. Infringers of copyright render themselves liable for prosecution.
 */

import { Button, Tooltip } from "@material-ui/core";
import { GridCellParams } from '@mui/x-data-grid';

export function renderCellExpand(params: GridCellParams) {
    const value = params.value?.toString() || "";
    if (value.length > 20)
        return <>
            {value.substring(0, 30)}...<Tooltip interactive arrow title={value}>
                <Button color="primary">Show All</Button>
            </Tooltip>
        </>
    else
        return <>{value}</>;
}